<template>
  <div>
    <FrameForm ref="frameForm" :component-param="'repair_' + stationId" v-if="showForm" :disabled="true"
               :init-data="formData"></FrameForm>
    <el-form disabled label-width="140px" v-if="formData">
      <el-form-item label="照片:" v-if="formData.imageList">
        <KfImageViewer :imageList="formData.imageList"/>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>

export default {
  name: "SnSearchDetail",
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      itemLog: {},
      formData: {},
      text: '',
      showForm: true,
      stationId: '',
    };
  },
  created() {
    this.getDetailData()
  },
  computed:{
  },
  methods:{
    async getDetailData(){
      this.showForm = false;
      this.itemLog = await this.$http('repairItemService.getDataDetailById',{id:this.componentParam})
      if (this.itemLog){
        this.formData = this.itemLog.formData
        console.log("this.formData-=",this.formData)
        this.stationId = this.itemLog.station_id
        this.showForm = true;
        if (this.formData.board_sn) {
          this.text += '整机主板SN:' + this.formData.board_sn
        }
      }
    },
  }
}
</script>

<style scoped>

</style>